import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilDadosLogado } from './util.logado';

@Injectable()
export class LoginServico {
    //public sub = "http://localhost:62195/api/Login/";
    //public sub = "http://implantacao.sisprevweb.com.br/webapiportalsergipe/api/Login/";
    //public sub = "http://implantacao.sisprevweb.com.br/PortalAl/webapiportalsergipe/api/Login/";
    //public sub = "http://proxima.sisprevweb.com.br/NovoPortalSergipe/webapiportalsergipe/api/Login/";
    //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipe/api/Login/";
    //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipehomologacao/api/Login/";
    constructor(
        private http: Http,
        private router: Router,
        private UtilDadosLogado: UtilDadosLogado
    ) { }

    login(usuario: string, senha: string) {
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Login/Autenticar", JSON.stringify({ usuario: usuario, senha: senha }), options)
            .map((response: Response) => {
                let dados = response.json()[0];
                if (dados && dados.token) {
                    //alert("oi");
                    //
                    console.log(dados);
                    //localStorage.setItem('Token', JSON.stringify(dados.token));
                    localStorage.setItem('AcessoAdm', JSON.stringify(dados));
                }
            });
    }

    logout() {
        localStorage.removeItem('AcessoAdm');
        this.router.navigate(['/login']);
    }

}